<template>
	<div class="font-h5-regular color-gy-9">
		<Tag :content="item" style="display: inline-block" v-for="(item, index) in row.roleName" :key="index" class="mr-4"></Tag>
	</div>
</template>

<script>
import mixin from '@/components/tableCells/mixin.js';
import Tag from '@/components/ui/tag';
export default {
	mixins: [mixin],
	components: {
		Tag,
	},
	computed: {},
};
</script>

<style lang="less">
.placeholderInstitution {
	background: @color-b2;
	border-radius: 100px;
	width: 32px;
	height: 32px;
	display: flex;
	align-items: center;
	justify-content: center;
}
</style>